import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import drawerBarStyles from '@/common/components/NavigationBar/DrawerBar.styles';
import { getMarketingSiteUrl } from '@/app/config';
import { useLocale } from '@/common/hooks';
import {
  CONTACT_US_URL,
  TERMS_URL,
  PRIVACY_URL,
} from '@/common/constants/constants';

const Footer = () => {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const legalDisclaimerUrl = getMarketingSiteUrl('/legal-disclaimer', locale);

  return (
    <Box sx={drawerBarStyles.footerLinks}>
      <a href={CONTACT_US_URL} target="_blank" rel="noreferrer">
        {t('Contact us')}
      </a>
      <a href={TERMS_URL} target="_blank" rel="noreferrer">
        {t('Terms')}
      </a>
      <a href={PRIVACY_URL} target="_blank" rel="noreferrer">
        {t('Privacy')}
      </a>
      <a href={legalDisclaimerUrl} target="_blank" rel="noreferrer">
        {t('Legal Disclaimer')}
      </a>
    </Box>
  );
};

export default Footer;
